import React from 'react'

function Divider() {
  return (
    <div className='p-[0.5px] bg-custom1'>

    </div>
  )
}

export default Divider
